/**
 * These IconCodes all originate from Antd library
 * for more icon codes:
 * @see https://ant.design/components/icon/
 * */
export enum IconCodes {
    AlertOutlined = "AlertOutlined",
    ApartmentOutlined = "ApartmentOutlined",
    AreaChartOutlined = "AreaChartOutlined",
    AuditOutlined = "AuditOutlined",
    BookOutlined = "BookOutlined",
    ControlOutlined = "ControlOutlined",
    CreditCardOutlined = "CreditCardOutlined",
    FieldNumberOutlined = "FieldNumberOutlined",
    FilePptOutlined = "FilePptOutlined",
    FileSyncOutlined = "FileSyncOutlined",
    FileTextOutlined = "FileTextOutlined",
    FundOutlined = "FundOutlined",
    HomeOutlined = "HomeOutlined",
    PartitionOutlined = "PartitionOutlined",
    PrinterOutlined = "PrinterOutlined",
    FlagOutlined = "FlagOutlined",
    CodeSandboxOutlined = "CodeSandboxOutlined",
    DeleteOutlined = "DeleteOutlined",
    ShopOutlined = "ShopOutlined",
    SyncOutlined = "SyncOutlined",
    SwapOutlined = "SwapOutlined",
    FilterOutlined = "FilterOutlined",
    ExportOutlined = "ExportOutlined",
    ImportOutlined = "ImportOutlined",
    CopyOutlined = "CopyOutlined",
    AppstoreAddOutlined = "AppstoreAddOutlined",
    RedoOutlined = "RedoOutlined",
    SearchOutlined = "SearchOutlined",
}
